module.exports = __webpack_public_path__ + "img/step9.8b26bcd5.png";